import React, { useState } from 'react';
import {
  Button, Radio, SelectionControlLabel, Typography
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { MobileAwareOverlay } from '../../../components/MobileAwareOverlay';
import { AddressType } from './types';
import './confirmAddressModal.scss';
import {
  IconWithRoundBorder
} from '../IconWithRoundBorder/IconWithRoundBorder';
import { formatAddress } from './common';
import { addAnalyticEvent } from '../../analytics/common';
import { confirmMailingEvent, unverifiedMailingEvent } from '../../analytics/address';
import LinkButton from '../LinkButton';

export const SelectAddressModal = ({
  isMobile, handleClose, openAddressEntryModal, verifiedAddress, address, useVerifiedAddress,
  unsubscribeVerifiedAddress, unsubscribeAddress
}) => {

  const [verifiedAddressSelected, setVerifiedAddressSelected] = useState(useVerifiedAddress);

  const handleConfirmClick = () => {
    if (verifiedAddressSelected) {
      addAnalyticEvent(confirmMailingEvent);
      unsubscribeVerifiedAddress();
    } else {
      addAnalyticEvent(unverifiedMailingEvent);
      unsubscribeAddress();
    }
  };

  return (
    <MobileAwareOverlay
      modalClass="preferences-modal"
      onClose={handleClose}
      open
    >
      <div className="sui-grid sui-gap-4 preferences-modal__content">
        <div className="sui-flex sui-items-center sui-gap-4">
          {!isMobile && (
            <IconWithRoundBorder
              iconSrc="https://assets.homedepot-static.com/images/v1/mailbox.svg"
              iconWidth="27.7px"
            />
          )}
          <Typography variant="h4">Confirm Your Mailing Address</Typography>
        </div>
        <Typography variant="body-base" weight="bold">
          The address entered matched the verified address provided by United Parcel
          Service (UPS). The Home Depot recommends using the Verified Address option.
          We may not be able to remove the Unverified Address you entered because it
          may be invalid.
        </Typography>
        <Typography variant="body-base">
          Please confirm the correct address or{' '}
          <LinkButton onClick={openAddressEntryModal} testId="unverified-try-again">
            try again
          </LinkButton>
          .
        </Typography>

        <Typography variant="body-base" weight="bold">Verified Mailing Address</Typography>
        <div className="sui-border-solid sui-border-1 sui-border-primary sui-rounded-base sui-p-4">
          <SelectionControlLabel value="verified" label={formatAddress(verifiedAddress)}>
            <Radio
              id="verifiedAddress"
              checked={verifiedAddressSelected}
              value="verifiedAddress"
              name="verifyAddress"
              onChange={() => { setVerifiedAddressSelected(true); }}
            />
          </SelectionControlLabel>
        </div>

        <Typography variant="body-base" weight="bold">Unverified Mailing Address</Typography>
        <div className="sui-border-solid sui-border-1 sui-border-primary sui-rounded-base sui-p-4">
          <SelectionControlLabel value="unverified" label={formatAddress(address)}>
            <Radio
              id="unverifiedAddress"
              checked={!verifiedAddressSelected}
              value="unverifiedAddress"
              name="verifyAddress"
              onChange={() => { setVerifiedAddressSelected(false); }}
            />
          </SelectionControlLabel>
        </div>

        <hr className="hr-line" />
        <div className="sui-grid sui-grid-cols-12">
          <div className="sui-col-span-8" />
          <div className="sui-col-span-4">
            <Button
              onClick={handleConfirmClick}
              fullWidth
            >
              Confirm
            </Button>
          </div>
        </div>
      </div>
    </MobileAwareOverlay>
  );
};

SelectAddressModal.propTypes = {
  isMobile: PropTypes.bool,
  unsubscribeAddress: PropTypes.func.isRequired,
  unsubscribeVerifiedAddress: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  openAddressEntryModal: PropTypes.func.isRequired,
  verifiedAddress: AddressType.isRequired,
  address: AddressType.isRequired,
  useVerifiedAddress: PropTypes.bool.isRequired,
};

SelectAddressModal.defaultProps = {
  isMobile: false,
};
